import React from "react";
import { Switch, Route } from "react-router";
import { render } from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { autoRefresh } from "./utils/helpers";
import AppUpdate from "./Containers/Common/AppUpdate/AppUpdate";

render(
  <>
    <Router>
      <Switch>
        <Route path="/" component={App} />
      </Switch>
    </Router>
    <AppUpdate />
  </>,
  document.getElementById("root"),
);

serviceWorker.unregister();
// serviceWorker.register(toast);

autoRefresh();
